export default __webpack_public_path__ + "static/gitlab-7e6bf03489508acbbda58c53ead3a4c5.png";